import { autoserialize } from 'cerialize';

export class AbstractCountedResultList {
  @autoserialize
  totalCount: number;
}
